import {
	useQueryClient,
	useMutation,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {
	updatePerson,
	type UpdatePersonResult,
	type UpdatePersonRequestOptions,
	type QueryError,
} from '../updatePerson';
import {splitEventHandler} from '@netx/core-next/utils';

export * from '../updatePerson';

export type UseReactQueryUpdatePersonOptions = UseMutationOptions<
	UpdatePersonResult,
	QueryError,
	UpdatePersonRequestOptions,
	UpdatePersonResult
>;

export const useReactQueryUpdatePerson = (
	options: Omit<UseReactQueryUpdatePersonOptions, 'mutationFn'> = {},
) => {
	const queryClient = useQueryClient();
	return useMutation<
		UpdatePersonResult,
		QueryError,
		UpdatePersonRequestOptions,
		UpdatePersonResult
	>({
		mutationFn: updatePerson,
		...options,
		onSuccess: splitEventHandler(
			options.onSuccess,
			(data, variables, context) => {
				queryClient.invalidateQueries(['getPeople']);
				queryClient.invalidateQueries(['getAssetFaces']);
			},
		),
	});
};

export default useReactQueryUpdatePerson;
